import { ChevronLeft, ChevronRight } from "lucide-react";

export default function StickyBottom({
  onNext,
  onBack,
  nextLabel = "Continue",
  backLabel = "Back",
  nextDisabled = false,
  showBack = true,
  rightContent,
  testId = "sticky-next",
}) {
  return (
    <div
      className="fixed bottom-0 inset-x-0 z-40 backdrop-blur-xl bg-[#0A0C10]/90 border-t border-white/5 no-print"
      data-testid="sticky-bottom-bar"
    >
      <div className="max-w-2xl mx-auto px-4 pr-28 sm:pr-4 py-3.5 flex items-center gap-3">
        {showBack && (
          <button
            type="button"
            className="btn-ghost flex items-center gap-1 px-4"
            onClick={onBack}
            data-testid="back-button"
          >
            <ChevronLeft size={18} />
            <span className="hidden sm:inline">{backLabel}</span>
          </button>
        )}
        {rightContent ? (
          <div className="flex-1">{rightContent}</div>
        ) : (
          <button
            type="button"
            onClick={onNext}
            disabled={nextDisabled}
            className="btn-primary flex-1 flex items-center justify-center gap-2"
            data-testid={testId}
          >
            <span>{nextLabel}</span>
            <ChevronRight size={18} />
          </button>
        )}
      </div>
    </div>
  );
}
